import Radium from 'radium';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import {
  gainsboro,
  ghost,
  linkBlue,
  primaryBlack,
  silver
} from 'helpers/colors';

import Tokens from 'styles/tokens';

interface IAvomaTextAreaProps
  extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'value'> {
  label?: string;
  optional?: boolean;
  noAsterisk?: boolean;
  noOptionalText?: boolean;
  helperComponent?: React.ReactNode;
  labelStyle?: React.CSSProperties;
  containerStyles?: React.CSSProperties;
  userStyles?: React.CSSProperties;
  textareaClassName?: string;
  maxlength?: number;
  value?: string | null;
  error?: string;
  type?: string;
}

const AvomaTextArea = (props: IAvomaTextAreaProps) => {
  const {
    placeholder,
    label = '',
    name = '',
    rows = 3,
    value = null,
    userStyles = {},
    optional = false,
    containerStyles = {},
    maxlength = 1000,
    helperComponent = false,
    labelStyle,
    disabled = false,
    noAsterisk = false,
    textareaClassName,
    noOptionalText = false,
    error,
    type: _type,
    ...rest
  } = props;

  void _type;

  const newVal = value !== null ? value : '';
  return (
    <div className='field' style={{ ...styles.container, ...containerStyles }}>
      {label && (
        <label htmlFor={name} className='textfield-label' style={labelStyle}>
          {label}
          {!optional && (
            <span style={{ color: Tokens.colors.avomaRed }}>
              {!noAsterisk && '*'}
            </span>
          )}
          {optional && !noOptionalText && (
            <span style={styles.optional}>(optional)</span>
          )}
        </label>
      )}
      {helperComponent}
      <textarea
        disabled={disabled}
        style={{ ...styles.textarea, ...userStyles }}
        placeholder={placeholder}
        className={twMerge(
          'avoma-input avoma-textarea textarea-avoma',
          textareaClassName
        )}
        onFocus={e => {
          const { value } = e.target;
          e.target.setSelectionRange(value.length, value.length);
        }}
        rows={rows}
        name={name}
        value={newVal}
        maxLength={maxlength}
        {...rest}
      />
      {error && <p className='text-red text-xs mt-1'>{error}</p>}
    </div>
  );
};

const styles: any = {
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  textarea: {
    boxSizing: 'border-box',
    padding: `${Tokens.spacing.one} ${Tokens.spacing.onehalf}`,
    color: primaryBlack,
    backgroundColor: ghost,
    ...Tokens.type.bodyS,
    letterSpacing: 'var(--app-letter-spacing-default)',
    borderRadius: '3px',
    border: `1px solid ${gainsboro}`,
    ':focus': {
      outline: 'none',
      border: `1px solid ${linkBlue}`
    },
    ':hover': {
      border: `1px solid ${Tokens.colors.silverLight}`
    },
    ':disabled': {
      cursor: 'not-allowed',
      opacity: '0.4'
    },
    resize: 'none'
  },
  optional: {
    marginLeft: Tokens.spacing.half,
    color: silver,
    fontWeight: 'normal'
  }
};

export default Radium(AvomaTextArea);
